<template>
  <div class="Skelet-Item" :style="get_styleValue"></div>
</template>

<script setup>
  import { computed } from 'vue';
  import { Props } from './scripts/props.js';
  //---------------------------------
  const props = defineProps(Props());
  //---------------------------------
  const get_styleValue = computed(() => `
    max-height: ${props.height}px;
    min-height: ${props.height}px;
    border-radius: ${props.radius}px;
  `);
</script>

<style lang="scss">
  @import "./styles/_styles";
</style>